import * as Yup from "yup";
export const loginInitial={
    email:'',password:'',
}

export const registerInitial={
    email:'',password:'',username:'',
}

export const forgotPasswordInitial={
    email:'',
}
export const loginSchema=Yup.object().shape({
    email:Yup.string().required("Email is required").email(),
    password:Yup.string().required("Password is required")
    });

export const registerSchema=Yup.object().shape({
    email:Yup.string().required("Email is required").email(),
    password:Yup.string().required("Password is required").min(6).max(20),
    username:Yup.string().required("Username is required").max(50),
    // recaptcha:Yup.string().required("Please select captcha"),
    });


export const forgotPasswordSchema=Yup.object().shape({
    email:Yup.string().required().email(),
});


export const changePassword=Yup.object().shape({
    oldPassword:Yup.string().required(),
    newPassword:Yup.string().required().matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*[\]{}()?"\\,><':;|_~`=+-])[a-zA-Z\d!@#$%^&*[\]{}()?"\\,><':;|_~`=+-]{12,99}$/,
        'Must contain at least 12 Characters, 1 Uppercase, 1 Lowercase, 1 Special Character, and 1 Number'
    ),
    confirmPassword:Yup.string().required().oneOf([Yup.ref("newPassword")])
});

export const resetPassword=Yup.object().shape({
    password:Yup.string().required().matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*[\]{}()?"\\,><':;|_~`=+-])[a-zA-Z\d!@#$%^&*[\]{}()?"\\,><':;|_~`=+-]{12,99}$/,
        'Must contain at least 12 Characters, 1 Uppercase, 1 Lowercase, 1 Special Character, and 1 Number'
    ),
    password_confirmation:Yup.string().required().oneOf([Yup.ref("password")])
});
